import { cx } from '@linaria/core';

import { SizeCommonButtonBase } from '~shared/ui/atoms/ButtonBase/SizeCommonButtonBase';
import type { SizeButtonBaseProps } from '~shared/ui/atoms/ButtonBase/types';

import { styledButton } from './styles';

export const ButtonPrimary = ({ className, ...props }: SizeButtonBaseProps) => (
	<SizeCommonButtonBase className={cx(className, styledButton)} {...props} />
);
